module.exports = __webpack_public_path__ + "img/bullsi_blank.b360efbd.png";